import LearnMoreFlex from "components/styled/LearnMoreFlex.styled";

const LearnMoreItem = ({ title, content, textColor="#fff", backgroundColor, linkUnderlineColor="#fbaa2e" }) => {
  return (
    <LearnMoreFlex backgroundColor={backgroundColor} textColor={textColor} linkUnderlineColor={linkUnderlineColor}>
      <div className="learnmore-title">{title}</div>
      <div className="learnmore-content" dangerouslySetInnerHTML={{ __html: content }}></div>
    </LearnMoreFlex>
  );
};

export default LearnMoreItem;
